import { ReactNode, useMemo, useState } from 'react';
import { contextFactory, useFormField } from '@frontend/design-system';
import { DefaultViewConfig, ListBoxView, PrimaryViewConfig } from './types';

type ListBoxContextType = {
  currentView: ListBoxView;
  defaultViewConfig?: DefaultViewConfig;
  primaryViewConfig?: PrimaryViewConfig;
  searchFieldProps?: ReturnType<typeof useFormField<'text'>>;
  onClose: () => void;
  setCurrentView: (state: ListBoxView) => void;
};

export const [ListBoxContext, useListBoxContext] = contextFactory<ListBoxContextType>(
  'useListBoxContext must be used within a ListBoxProvider'
);

type ListBoxProviderProps = {
  children: ReactNode;
  defaultViewConfig?: DefaultViewConfig;
  primaryViewConfig?: PrimaryViewConfig;
  searchFieldProps?: ReturnType<typeof useFormField<'text'>>;
  onClose: () => void;
};

export const ListBoxProvider = ({
  children,
  defaultViewConfig,
  primaryViewConfig,
  searchFieldProps,
  onClose,
}: ListBoxProviderProps) => {
  const [currentView, setCurrentView] = useState(ListBoxView.Default);

  const value = useMemo(
    () => ({
      currentView,
      defaultViewConfig,
      primaryViewConfig,
      searchFieldProps,
      onClose,
      setCurrentView,
    }),
    [currentView, defaultViewConfig, primaryViewConfig, searchFieldProps, onClose]
  );

  return <ListBoxContext.Provider value={value}>{children}</ListBoxContext.Provider>;
};
